var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M4.83789 6L8.83789 10L12.8379 6","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }